import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link, redirect, useNavigate } from "react-router-dom";
import { ArrowLeft,Search } from "lucide-react";
import Swal from "sweetalert2";

const PackagesManage = () => {
const urlLink='https://www.patratravels.com/holidays/';
  const navigate = useNavigate();
const [searchTerm, setSearchTerm] = useState("");
  const [Countrys, setCountrys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);

  // =========================
  // FETCH Country DATA
  // =========================

  useEffect(() => {
    fetchCountryData();
  }, []);

  const fetchCountryData = async () => {
    try {
      const res = await api.get("/adminHolidays/get-packages-name");
      setCountrys(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Package Name data");
    }
  };

  // =========================
  // DELETE Country
  // =========================

const handleDelete = async (id) => {
  const confirm = await Swal.fire({
    title: "Delete Packages Name?",
    text: "Do you want to delete this Packages Name?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes Delete",
    confirmButtonColor: "#d33",
  });

  if (!confirm.isConfirmed) return;

  try {
    const res = await api.delete(
      `/adminHolidays/delete-packages-name/${id}`
    );

    if (res.data.success) {
      await Swal.fire(
        "Deleted!",
        "Packages Name deleted successfully",
        "success"
      );

      fetchCountryData();
    } else {
      toast.error(
        res.data.message || "Failed to delete Packages Name"
      );
    }
  } catch (error) {
    console.log(error);

    toast.error(
      error?.response?.data?.message ||
        "Failed to delete Packages Name"
    );
  }
};

  // =========================
  // STATUS CHANGE
  // =========================

  const handleStatusChange = async (id, status) => {
  try {
    const res = await api.put("/adminHolidays/packages-name-status", {
      id,
      is_active: status,
    });

    if (res.data.success) {
      toast.success("Status updated");
      fetchCountryData();
    } else {
      toast.error(res.data.message || "Failed to update status");
    }
  } catch (error) {
    console.log(error);

    toast.error(
      error?.response?.data?.message || "Failed to update status"
    );
  }
};



const handleEditCountry = (catId) => {
  navigate(`/holidays/packages/edit-packages-name/${catId}`);
};

  // =========================
  // PAGINATION
  // =========================

  // const indexOfLast = currentPage * perPage;
  // const indexOfFirst = indexOfLast - perPage;
  // const currentItems = Countrys.slice(indexOfFirst, indexOfLast);
  // const totalPages = Math.ceil(Countrys.length / perPage);



   // =========================
  // FILTER & SEARCH
  // =========================
  const filteredCountries = Countrys.filter((cat) => {
    const term = searchTerm.trim().toLowerCase();

    const countryName = String(cat.packages_name || "").toLowerCase();
    const countrySlug = String(cat.packages_slug || "").toLowerCase();

    return (
      countryName.includes(term) ||
      countrySlug.includes(term)
    );
  });

  // =========================
  // PAGINATION
  // =========================
  const totalPages = Math.ceil(filteredCountries.length / perPage);

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;

  const currentItems = filteredCountries.slice(
    indexOfFirst,
    indexOfLast
  );

  // Search change hone par first page par jaayein
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };


  // =========================
  // JSX
  // =========================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between">
          <h4 className="fw-bold">Manage Packages Name</h4>
<div style={{display:"flex"}}>
<div className="input-group input-group-sm" style={{width: '200px',marginRight:"10px"}}>
                <span className="input-group-text bg-white"><Search size={16}/></span>
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search..." 
                  value={searchTerm} 
                  onChange={handleSearch}
                />
</div>
          <Link
            to={"/holidays/packages/add-packages-name"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} /> Add Packages Name
          </Link>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="table-responsive">

          <table className="table table-hover table-sm align-middle mb-0">

            <thead className="bg-light">
              <tr>
                <th>Sl</th>
                <th>Package Name</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-muted">
                    No Packages Name Found
                  </td>
                </tr>
              ) : (

                currentItems.map((cat, index) => (

                  <tr key={cat.packages_id}>

                    <td>{indexOfFirst + index + 1}</td>

                    <td>{cat.packages_name}</td>

                   <td>
{cat.packages_slug}
</td>

                    {/* STATUS */}
                 <td>
 {!cat.meta_title ? (
    <span style={{color:"red",fontSize:"14px"}}>Update Country SEO Details</span>
  ) : (
    <select
      className={`form-select form-select-sm ${
        cat.is_active == 1 ? "text-success" : "text-danger"
      }`}
      value={cat.is_active}
      onChange={(e) =>
        handleStatusChange(cat.packages_id, e.target.value)
      }
    >
      <option value="1">Active</option>
      <option value="0">Inactive</option>
    </select>
  )}
</td>

                    {/* ACTION */}
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleEditCountry(cat.packages_id)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(cat.packages_id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}
        <div className="d-flex justify-content-center mt-3">
          <ul className="pagination">

            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                Next
              </button>
            </li>

          </ul>
        </div>

      </div>

    </div>
  );
};

export default PackagesManage;